export default {
  "finishAuthority": "Seul le marqueur rond peut finir ce tour.",
  "finishDraft": "Confirmer ou réinitialiser les scores avant de terminer.",
  "finishScoreRetry": "Les scores n'ont pas été sauvegardés. Vérifiez votre connexion et votre entrée.",
  "finishSavingScores": "Attendre des économies de score pour être reconnu.",
  "finishStatsRetry": "Résolvez ou réessayez des statistiques non sauvegardées dans la vue Hole.",
  "finishSavingStats": "J'attends que vos statistiques finissent par économiser.",
  "finishMissingScores": "Chaque joueur a besoin d'un score confirmé sur chaque trou.",
  "finishingRound": "Finir...",
  "holeSaveError": "Votre position de visualisation ne peut pas être sauvegardée. Les scores sont sauvegardés séparément.",

  "scorecardHeading": "Tableau de bord",
  "playersScored": "Joueurs avec score : {count} sur {total}",
  "yourScorecard": "Votre carte de points",
  "roundView": "Vue ronde",
  "scoreCoverageShort": "Parcours comparables : {count} sur {total}",
  "offline": "Offline — attendant de Enregistrer",
  "noPutts": "Pas de putts enregistrés",
  "excludedReasons": "Exclus dans cette fenêtre: {scores} tours avec des scores incomplets; {par} tours avec par historique manquant.",
  "playVideo": "Jeu trou {number} vidéo",
  "pauseVideo": "Trou de la douleur {number} vidéo",
  "puttChoice": "Putts : {count}",
  "exactPutts": "Nombre exact de putt",
  "apply": "Appliquer",
  "cancel": "Annuler",
  "tapToClear": "Appuyez sur une réponse sélectionnée pour effacer.",
  "personal": "Ma carte de score",
  "group": "Groupe",
  "cardView": "Vue de la carte Score",
  "unrecorded": "Non enregistré",
  "strokes": "AVC enregistrés",
  "scoredCoverage": "Trous avec score : {count} sur {total}",
  "parCoverage": "Trous au par fiable : {count}",
  "legend": "Scorecard aide",
  "legendHelp": "FW : fairway. GIR : green en régulation. ✓ Atteint / Oui ; × Manqué / Non ; — non enregistré ; N/A sans objet. Touchez un numéro de trou pour revenir à la saisie du score.",
  "hole": "Trou",
  "par": "Par",
  "score": "Score",
  "goHole": "Aller au trou {number}",
  "recordedStrokes": "Courses enregistrées",
  "continueHole": "Continuer au trou {number}",
  "draft": "Brouillon",
  "holePosition": "{number} / {total}",
  "holeNumber": "Trou {number}",
  "strokeIndex": "SI",
  "metres": "m",
  "yards": "yd",
  "card": "Carte",
  "finishRound": "Terminé.",
  "swipeCard": "Swipeable trou scorecard",
  "holeNavigation": "Trou de navigation",
  "previousHole": "Trouble précédent",
  "nextHole": "Prochain trou",
  "reviewCard": "Carte de contrôle",
  "guest": "Invité",
  "scorer": "Scoreur",
  "member": "Membre",
  "toPar": "par rapport au par",
  "reset": "Réinitialiser",
  "confirmScore": "Confirmer {score}",
  "decreaseScore": "Diminution du score de {name}",
  "increaseScore": "Augmenter le score de {name}",
  "confirmPlayerScore": "Confirmer la note {score} pour {name}",
  "draftScore": "Notation du projet {score}",
  "savedScore": "Score enregistré {score}",
  "keepingCard": "{name} garde cette carte de score.",
  "scoringTrend": "Tendance de notation",
  "viewData": "Voir les données",
  "roundsLogged": "Ronds connectés",
  "recentRounds": "Cycles récents",
  "firstTitle": "Votre progression commence par une ronde",
  "firstHelp": "Complétez un tour pour suivre vos scores. Les statistiques optionnelles vous aident à comprendre votre jeu.",
  "startRound": "Commencez par un tour",
  "puttingHelp": "Comptez vos coups sur le vert.",
  "fairwayHelp": "Enregistrez si votre photo de tee trouve le chenal sur les par 4 et 5 trous.",
  "noMatch": "Pas de ronds correspondant à ces filtres",
  "noMatchHelp": "Choisissez un autre parcours, le tee ou le nombre de trous pour voir vos tours.",
  "resetFilters": "Réinitialiser les filtres",
  "benchmark": "Votre première référence",
  "benchmarkHelp": "Une autre ronde comparable commencera une tendance.",
  "whyOne": "Pourquoi un seul tour ?",
  "excludedHelp": "{count} autres rondes dans cette fenêtre manquent de scores complets ou fiable historique par.",
  "historicalHelp": "Vos rounds sont ici. Enregistrer les scores et les statistiques optionnelles dans les futures rondes pour construire vos progrès.",
  "noScoring": "Pas encore de rondes de marque comparables",
  "puttingTab": "Poussant",
  "fairwaysTab": "Fairways",
  "greensTab": "GIR",
  "perHole": "putts / trou enregistré",
  "coverage": "Couverture enregistrée",
  "loggedCoverage": "Terminés dans cette période : {count}",
  "viewRounds": "Vues rondes",
  "roundUnavailable": "Ce tour n'est pas disponible.",
  "returnGolf": "Retour au Golf",
  "loadingCard": "Chargez votre carte de score",
  "restoringCard": "Restauration de votre trou actuel et des scores",
  "completeError": "Chaque joueur a besoin d'un score sur chaque trou avant la ronde peut finir.",
  "stablefordNote": "Brèvement brut · Points Stableford en attendant des handicaps de jeu faisant autorité",
  "missingImage": "Hole aperçu non disponible",
  "roundComplete": "Ronde complète",

  "checkingLatest": "Vérification des dernières valeurs sauvegardées...",
  "conflictTitle": "Examen des statistiques modifiées",
  "conflictHelp": "Les Statistiques ont changé ailleurs. Révisez les dernières valeurs et votre projet.",
  "latestSaved": "Dernières enregistrées",
  "yourDraft": "Votre projet non sauvegardé",
  "editedFieldsOnly": "Seuls vos champs modifiés seront sauvegardés.",
  "useLatest": "Utiliser les dernières valeurs",
  "confirmReviewed": "Modifications révisées",
  "holeCount": "Trous : {count}",
  "evenPar": "Même par",

  "score_changed_reload": "Ce score a changé ailleurs. Le dernier score enregistré est affiché; votre valeur est conservée comme un projet. Révisez et confirmez-le à nouveau.",
  "putts_exceed_score": "Le score est inférieur aux putts enregistrés. Ajustez le score ou demandez au golfeur de revoir leurs putts.",
  "answersRecorded": "{hits} de {count} enregistrées",
  "partialPutts": "{total} putts sur {count} de {holes} trous enregistrés",
  "scoreSaveError": "Ce score n'a pas pu être enregistré. Votre score est conservé. Vérifiez votre connexion et votre entrée.",
  "title": "Mes statistiques de trous",
  "optional": "Facultatif",
  "support": "Ajouter autant ou aussi peu que vous le souhaitez",
  "putts": "Putts",
  "fairway": "Chenal",
  "gir": "Vert dans la réglementation",
  "girHelp": "Atteignant le vert de mise en pas plus que par moins deux coups.",
  "yes": "Oui",
  "no": "Non",
  "hit": "Frappé",
  "missed": "Manquée.",
  "clear": "Effacer",
  "clearAll": "Statistiques claires",
  "unknownPar": "Historique par indisponible; cette réponse ne peut pas être enregistrée.",
  "na": "N/A",
  "increase": "Augmenter les putts",
  "decrease": "Diminution des putts",
  "retry": "Réessayer",
  "saved": "enregistrés",
  "saving": "Enregistrement…",
  "unsaved": "Non-enregistrés",
  "saveError": "Impossible d’enregistrer les statistiques. Vos modifications sont conservées.",
  "progress": "Mon parcours de golf",
  "entrySubtitle": "Rondes, statistiques et amélioration",
  "subtitle": "Votre jeu, au fil du temps",
  "back": "Retour",
  "courseTee": "parcours / tees",
  "holes": "Trous",
  "period": "Période",
  "lastRounds": "Dernières {count} tours",
  "allTime": "Tout le temps",
  "overview": "Vue d’ensemble",
  "trends": "Tendances",
  "rounds": "Rondes",
  "scoreToPar": "Score à par",
  "average": "Moyenne à par",
  "best": "Le meilleur tour",
  "roundStats": "Vos statistiques rondes",
  "viewTrends": "Voir les tendances",
  "putting": "Poutines par trou",
  "fairways": "Fairways atteints",
  "greens": "Verts dans la réglementation",
  "lower": "C'est mieux.",
  "higher": "C'est mieux.",
  "par45": "Par 4 et 5",
  "recordedOnly": "Seuls les statistiques enregistrées sont incluses. Les entrées ignorées sont exclues.",
  "holesRecorded": "Trous enregistrés : {count}",
  "roundCoverage": "Parcours terminés : {count} · Trous pris en compte : {holes}",
  "scoreCoverage": "{count} de {total} tours avec des scores bruts complets et historique fiable.",
  "noMetric": "Aucune mesure enregistrée dans ce domaine.",
  "oneRound": "Un tour enregistré. D'autres rondes montreront une tendance.",
  "noHistory": "Pas de rondes terminées disponibles",
  "emptyHelp": "Remplissez un tour ou choisissez un autre filtre pour voir vos progrès.",
  "window": "L'histoire de tous les temps, analysée dans des pages allant jusqu'à 200 tours. Les valeurs et les graphiques décrivent la page actuelle.",
  "loading": "Chargez vos progrès...",
  "loadError": "Nous ne pouvions pas charger vos progrès.",
  "chartDescription": "Tourneaux chronologiques. Les entrées manquantes sont exclues. Données graphiques ouvertes pour les dates, les valeurs et la couverture enregistrée.",
  "chartData": "Données de la carte : dates, valeurs et couverture",
  "date": "Date",
  "value": "Valeur",
  "recorded": "Trous enregistrés",
  "pagination": "Pages d ' histoire ronde",
  "previous": "Précédent",
  "next": "Suivant",
  "errors": {
    "invalid_putts": "Entrez tout un nombre de putts de 0 à 30.",
    "putts_exceed_score": "Les putts ne peuvent pas dépasser le score brut enregistré. Ajuster les putts ou le score et la rentrée.",
    "fairway_not_applicable": "Les chaussées ne peuvent être enregistrées que par 4 et par 5 trous.",
    "par_unavailable": "Le par historique n'est pas disponible pour ce trou.",
    "stats_changed_reload": "Ces statistiques ont changé dans une autre demande. Révisez vos entrées avant de réessayer.",
    "round_not_editable": "Ce tour n'est plus modifiable. Vos changements n'ont pas été enregistrés."
  }
}
